import { lazyPage } from '../lib/lazyPage'

// Lazy-loaded pages — only loaded when the route is visited. main.tsx preloads
// the chunk for the first URL so prerendered HTML is swapped for the live page
// without a loading-spinner flash.
export const HowItWorks = lazyPage(() => import('./HowItWorks'))
export const Contact = lazyPage(() => import('./Contact'))
export const Settings = lazyPage(() => import('./Settings'))
export const Auth = lazyPage(() => import('./Auth'))
export const Dashboard = lazyPage(() => import('./Dashboard'))
export const NotFound = lazyPage(() => import('./NotFound'))
export const About = lazyPage(() => import('./About'))
export const FAQPage = lazyPage(() => import('./FAQ'))
export const Terms = lazyPage(() => import('./Terms'))
export const Privacy = lazyPage(() => import('./Privacy'))
export const LegalFaq = lazyPage(() => import('./LegalFaq'))
export const ForGeeks = lazyPage(() => import('./ForGeeks'))
export const Status = lazyPage(() => import('./Status'))
export const Download = lazyPage(() => import('./Download').then(m => ({ default: m.DownloadPage })))
export const Safety = lazyPage(() => import('./Safety'))
export const Workers = lazyPage(() => import('./Workers'))
export const Minecraft = lazyPage(() => import('./Minecraft'))

/** First-load preloaders, keyed by normalized path. Unknown paths load NotFound. */
export const routePreloaders: Record<string, () => Promise<unknown>> = {
  '/how-it-works': HowItWorks.preload,
  '/contact': Contact.preload,
  '/settings': Settings.preload,
  '/auth': Auth.preload,
  '/dashboard': Dashboard.preload,
  '/about': About.preload,
  '/faq': FAQPage.preload,
  '/terms': Terms.preload,
  '/privacy': Privacy.preload,
  '/legal-faq': LegalFaq.preload,
  '/for-geeks': ForGeeks.preload,
  '/status': Status.preload,
  '/download': Download.preload,
  '/safety': Safety.preload,
  '/workers': Workers.preload,
  '/minecraft': Minecraft.preload,
}
export const preloadNotFound = NotFound.preload
